import MultiProgramEnrollmentFlow from '@/app/pages/multi-program-enrollment/index'
import {
  MultiProgramDeviceFlowProvider,
  MultiProgramOnboardingFlowProvider,
} from '@/app/context/MultiProgram/MultiProgramFlowContexts'

export function MultiProgramEnrollmentDevicesPage() {
  return (
    <MultiProgramDeviceFlowProvider>
      <MultiProgramEnrollmentFlow />
    </MultiProgramDeviceFlowProvider>
  )
}

export function MultiProgramEnrollmentOnboardingPage() {
  return (
    <MultiProgramOnboardingFlowProvider>
      <MultiProgramEnrollmentFlow />
    </MultiProgramOnboardingFlowProvider>
  )
}
